import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=919dac4e&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=919dac4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919dac4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('919dac4e')) {
      api.createRecord('919dac4e', component.options)
    } else {
      api.reload('919dac4e', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=919dac4e&scoped=true", function () {
      api.rerender('919dac4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/five/instrument/disabilityEvaluationQuestionnaire/Main.vue"
export default component.exports